import { RadioButton, RadioGroup } from '@statsbomb/kitbag-components';
import { MetricValueMode } from '@statsbomb/parachute-types';
import { useAtom, useSetAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
import { metricValueModeTrackingMap, trackMetricDisplayFormatEvent } from '@/analytics/snowplow/tracking';
import { pageAtom } from '@/atoms/pagination';
import { metricValueModeAtom } from '@/atoms/table';

export const DataFormatToggle = () => {
  const { t } = useTranslation('visualisation');
  const [metricValueMode, setMetricValueMode] = useAtom(metricValueModeAtom);
  const setPage = useSetAtom(pageAtom);

  const handleDataFormatChange = (newMetricValueMode: MetricValueMode) => {
    const previousConfiguration = metricValueModeTrackingMap[metricValueMode];
    const updatedConfiguration = metricValueModeTrackingMap[newMetricValueMode];

    setMetricValueMode(newMetricValueMode);
    setPage(1);
    trackMetricDisplayFormatEvent({ previousConfiguration, updatedConfiguration });
  };

  return (
    <RadioGroup groupId="data-format-group" groupTitle={t('dataFormat.title')} size="regular">
      <RadioButton
        checked={metricValueMode === MetricValueMode.Per90}
        onChange={() => handleDataFormatChange(MetricValueMode.Per90)}
        id="data-format-per90"
        label={t('dataFormat.per90')}
        value={MetricValueMode.Per90}
        size="small"
      />
      <RadioButton
        checked={metricValueMode === MetricValueMode.Total}
        onChange={() => handleDataFormatChange(MetricValueMode.Total)}
        id="data-format-totals"
        label={t('dataFormat.totals')}
        value={MetricValueMode.Total}
        size="small"
      />
    </RadioGroup>
  );
};
